import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';

export const InfoText = () => {
  return (
    <div>
      <InlineText2>
        Мы не спамим и не передаем номера телефонов третьим лицам. Вам позвонят наиболее подходящие риэлторы. Им покажем
        другой номер телефона, который перенаправит звонок на ваш
      </InlineText2>
    </div>
  );
};

InfoText.displayName = 'InfoText';
